export default function productMatcher() {
    return {
        productsData: {},
        availableBrands: [],
        availableModels: [],
        matchedProducts: [],
        step: 1,
        totalSteps: 0,
        showResults: false,
        email: '',
        brandName: '',
        brandNameOther: '',
        modelName: '',
        modelNameOther: '',
        init() {
            this.productsData = JSON.parse(this.$el.dataset.products || '{}');
            this.availableBrands = Object.keys(this.productsData);
            this.totalSteps = this.$refs.steps.querySelectorAll('[data-step]').length;
        },
        updateAvailableModels() {
            if (this.brandName === 'other') {
                this.availableModels = ['other'];
                return;
            }

            if (!this.brandName || !this.productsData[this.brandName]) {
                this.availableModels = [];
                return;
            }

            this.availableModels = Object.keys(this.productsData[this.brandName].models).concat('other');
        },
        handleBrandChange() {
            if (this.brandName !== 'other') {
                this.brandNameOther = '';
            }

            this.updateAvailableModels();
            this.modelName = this.brandName === 'other' ? 'other' : '';
            this.modelNameOther = '';
            this.matchedProducts = [];
        },
        handleModelChange() {
            if (this.modelName !== 'other') {
                this.modelNameOther = '';
            }

            this.matchedProducts = [];
        },
        next() {
            if (this.step === 1 && this.$refs.email && !this.$refs.email.reportValidity()) {
                return;
            }

            if (this.step === 2) {
                if (this.$refs.brandName && !this.$refs.brandName.reportValidity()) {
                    return;
                }

                if (this.brandName === 'other' && this.$refs.brandNameOther && !this.$refs.brandNameOther.reportValidity()) {
                    return;
                }
            }

            if (this.step === 3) {
                if (this.$refs.modelName && !this.$refs.modelName.reportValidity()) {
                    return;
                }

                if (this.modelName === 'other' && this.$refs.modelNameOther && !this.$refs.modelNameOther.reportValidity()) {
                    return;
                }
            }

            if (this.step < this.totalSteps) {
                this.step += 1;
            }
        },
        submit() {
            if (this.$refs.modelName && !this.$refs.modelName.reportValidity()) {
                return;
            }

            if (this.modelName === 'other' && this.$refs.modelNameOther && !this.$refs.modelNameOther.reportValidity()) {
                return;
            }

            if (this.modelName === 'other') {
                this.populateContactForm(
                    'I am interested in one of your products for use with a ' +
                    (this.brandName === 'other' ? this.brandNameOther : this.brandName) +
                    ' ' +
                    this.modelNameOther +
                    ' oven.'
                );
                return;
            }

            this.matchedProducts = this.productsData[this.brandName].models[this.modelName].products || [];
            this.showResults = true;
        },
        populateContactForm(message) {
            const salesQuoteRequest = document.getElementById('sales-and-quote-request');
            const contactForm = salesQuoteRequest ? salesQuoteRequest.querySelector('form') : null;

            if (!contactForm) {
                return;
            }

            const emailField = contactForm.querySelector('input[type=email]');
            const textareaField = contactForm.querySelector('textarea');

            if (emailField) {
                emailField.value = this.email;
            }

            if (textareaField) {
                textareaField.value = message;
            }

            contactForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        },
        populateContactMessage(productNumber) {
            this.populateContactForm(
                'I am interested in Product No. ' +
                productNumber +
                ' for use with a ' +
                this.brandName +
                ' ' +
                this.modelName +
                ' oven.'
            );
        },
        prev() {
            if (this.step > 1) {
                this.step -= 1;
            }
        },
        restart() {
            this.showResults = false;
            this.step = 1;
            this.email = '';
            this.brandName = '';
            this.brandNameOther = '';
            this.modelName = '';
            this.modelNameOther = '';
            this.availableModels = [];
            this.matchedProducts = [];
            this.$refs.form.reset();
        },
    };
}
